(() => {
  if (window.grayishRefreshDiscountBadges) {
    window.grayishRefreshDiscountBadges();
    return;
  }
  function refresh() {
    document.querySelectorAll('[data-grayish-discount-badge]').forEach(badge => {
      const pricing = badge.closest('[data-product-pricing]');
      const root = badge.closest('.product-details');
      const data = pricing?.querySelector('[data-grayish-discount-variants]');
      const input = root?.querySelector('form[action*="/cart/add"] [name="id"]');
      if (!data || !input) return;
      let variants;
      try { variants = JSON.parse(data.textContent); } catch { return; }
      const variant = variants.find(item => String(item.id) === String(input.value));
      if (!variant) { badge.style.display = 'none'; return; }
      const price = Number(variant.price);
      const compare = Number(variant.compare_at_price);
      const savings = compare > price && compare > 0 ? Math.round((compare - price) * 100 / compare) : 0;
      const amount = badge.querySelector('[data-price-percent-saved]');
      if (amount) amount.textContent = String(savings);
      badge.style.display = savings > 0 ? '' : 'none';
    });
  }
  function schedule() {
    refresh();
    window.setTimeout(refresh, 0);
    window.setTimeout(refresh, 120);
    window.setTimeout(refresh, 400);
  }
  window.grayishRefreshDiscountBadges = refresh;
  document.addEventListener('change', schedule);
  ['variant:change', 'product:variant-change', 'theme:variant:change', 'shopify:section:load'].forEach(event => document.addEventListener(event, schedule));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true});
  else refresh();
})();
